import { render, staticRenderFns } from "./data-categories.vue?vue&type=template&id=9e786df6&scoped=true&"
import script from "./data-categories.vue?vue&type=script&lang=js&"
export * from "./data-categories.vue?vue&type=script&lang=js&"
import style0 from "./data-categories.vue?vue&type=style&index=0&id=9e786df6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e786df6",
  null
  
)

export default component.exports